// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__24yxt","info":"UpdateTermsInfo_info__2WHv6"};